export const isMobileDevice = (): boolean => {
  if (typeof navigator === "undefined") return false;

  const userAgent =
    navigator.userAgent || navigator.vendor || (window as any).opera;

  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    userAgent.toLowerCase()
  );
};
